import createEmailCampaignsModule from '@/store/dynamic-campaigns/dynamic_campaigns'

export default createEmailCampaignsModule()
